import { useEffect, useState } from "react";

// Phone = below `md` (767 px). `maxWidth` 1023 (below `lg`) tells whether the bottom navigation is shown: phones and tablets.
export default function useIsMobile(maxWidth = 767) {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const update = () => setIsMobile(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [query]);

  return isMobile;
}
